import { Eyebrow, Reveal } from "../site/motion";

const Tile = ({ n, title, text, className = "" }) => (
  <div className={`flex h-full flex-col justify-between rounded-[28px] border-2 border-dano-ink p-6 sm:p-8 transition-transform duration-500 hover:-translate-y-1 ${className}`}>
    <span className="font-cond text-sm uppercase tracking-[0.2em]">{n}</span>
    <div className="mt-10">
      <h3 className="font-wide text-2xl sm:text-3xl uppercase leading-none">{title}</h3>
      <p className="mt-3 text-sm sm:text-base opacity-85">{text}</p>
    </div>
  </div>
);

export const Ingredients = () => (
  <section data-testid="ingredients-bento" className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-20 sm:py-28 lg:py-36">
    <Reveal className="max-w-3xl">
      <Eyebrow>What goes in</Eyebrow>
      <h2 className="mt-4 font-wide text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.92]">Real ingredients you recognize.</h2>
    </Reveal>
    <div className="mt-12 sm:mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-12 lg:auto-rows-[220px]">
      <Reveal className="sm:col-span-2 lg:col-span-5 lg:row-span-2">
        <div className="relative h-[420px] lg:h-full overflow-hidden rounded-[28px] spotlight-frame">
          <img src="/images/flatlay.jpg" alt="Whole ingredients laid out" className="h-full w-full object-cover" />
          <div className="absolute inset-x-4 bottom-4 rounded-2xl bg-dano-cream/90 p-4 backdrop-blur-md">
            <p className="font-cond text-sm uppercase tracking-[0.2em] text-dano-red">The whole list</p>
            <p className="font-wide text-lg uppercase leading-tight">Real food you can taste.</p>
          </div>
        </div>
      </Reveal>
      <Reveal className="lg:col-span-4" delay={0.05}><Tile n="01" title="Oats" text="Whole rolled oats for the base and the chew." className="bg-dano-gold text-dano-ink" /></Reveal>
      <Reveal className="lg:col-span-3" delay={0.1}><Tile n="02" title="Nut butters" text="Rich, real nut butters." className="bg-dano-cream text-dano-ink" /></Reveal>
      <Reveal className="lg:col-span-2" delay={0.05}><Tile n="03" title="Dates" text="Natural sweetness and binding." className="bg-dano-cream text-dano-ink" /></Reveal>
      <Reveal className="lg:col-span-2" delay={0.1}><Tile n="04" title="Honey" text="A touch, not a flood." className="bg-dano-sand text-dano-ink" /></Reveal>
      <Reveal className="sm:col-span-2 lg:col-span-3" delay={0.15}><Tile n="05" title="Protein" text="Quality protein, source being finalized." className="bg-dano-red text-dano-cream border-dano-red" /></Reveal>
    </div>
  </section>
);
